import Icon from '@material-ui/icons/Phone';
import React from 'react';
import { CreateButton } from '../../buttons';
import { EditDialog, Filter, ResourceList } from '../../controllers';
import { BooleanField, LinkField, ReferenceField, TextField } from '../../fields';
import { BooleanInput, NumberInput, ReferenceInput } from '../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <NumberInput
          source="priority"
        />
        <BooleanInput
          source="enabled"
        />
        <BooleanInput
          source="failover"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        {...props}
      >
        <ReferenceInput
          optionText="username"
          source="phone_id"
          required
        />
        <ReferenceInput
          source="call_queue_id"
          required
        />
        <NumberInput
          source="priority"
          required
        />
        <BooleanInput
          source="enabled"
          defaultValue
        />
        <BooleanInput
          source="failover"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <LinkField
          source="call_queue_id"
        />
        <ReferenceField
          reference="phones"
          source="phone_id"
        >
          <TextField
            source="username"
          />
        </ReferenceField>
        <TextField
          source="priority"
        />
        <BooleanField
          source="enabled"
        />
      </ResourceList>
    ),

  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <ReferenceInput
          optionText="username"
          source="phone_id"
          required
        />
        <ReferenceInput
          source="call_queue_id"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
